module.exports = __webpack_public_path__ + "img/3.66679dd1.png";